import {
  LoginApi,
  ResetPasswordApi,
  UserLogoutApi,
  getUserProfile,
  RefreshTokenApi,
  DealerLoginApi,
  DealerResetPasswordApi,
} from '../../../routes/apiRoutes';
import { axiosPost, axiosGet, authAPIInstance } from '../commonApis';

export const handleLogin = async (loginData) => {
  return await authAPIInstance.post(LoginApi, loginData);
};

export const handleDealerLogin = async (loginData) => {
  return await authAPIInstance.post(DealerLoginApi, loginData);
};

export const handleSendOTP = async (data) => {
  return await authAPIInstance.post(ResetPasswordApi, data);
};

export const handlePasswordReset = async (data) => {
  return await authAPIInstance.post(ResetPasswordApi, data);
};

export const handleDealerSendOTP = async (data) => {
  return await authAPIInstance.post(DealerResetPasswordApi, data);
};

export const handleDealerPasswordReset = async (data) => {
  return await authAPIInstance.post(DealerResetPasswordApi, data);
};

export const handleLogout = async (token = '') => {
  const response = await axiosGet(UserLogoutApi, token);
  return response.data;
};

export const handleGetUserProfile = async (token) => {
  const response = await axiosGet(getUserProfile, token);
  return response.data;
};

export const handleRefreshToken = () => {
  return async () => {
    const response = await axiosPost(RefreshTokenApi);
    return response.data;
  };
};
